export default __webpack_public_path__ + "static/media/image-5.8bb02c1d.png";